var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html } from 'lit';
import { property } from 'lit/decorators.js';
import { registerCustomElement } from '../utils/registerCustomElement';
import { unsafeSVG } from 'lit/directives/unsafe-svg.js';
import { styleMap } from 'lit/directives/style-map.js';
import { classMap } from 'lit/directives/class-map.js';
import * as Icons from './IconItems';
import { styles } from './styles';
let Icon = class Icon extends LitElement {
    constructor() {
        super(...arguments);
        this.name = '';
        this.fill = '';
        this.width = '24px';
        this.height = '24px';
        this.class = '';
        /*
          invert color
      
          @TODO:
          Icons will need to be themeable
        */
        this.inverted = false;
    }
    render() {
        const iconComponent = Icons.iconItems[this.name];
        // if no icon
        if (!iconComponent) {
            return html ``;
        }
        const icon = iconComponent();
        // combine css classes if passed by prop
        const cssClassList = {
            'grain-icon': true,
            // only include if true
            [this.class]: !!this.class,
            'is-inverted': this.inverted,
        };
        // wrapper styles
        const wrapperStyles = {
            width: this.width || null,
            height: this.height || null,
            color: this.fill || null,
        };
        return html `
      <span role="img" class=${classMap(cssClassList)} part="grain-icon">
        <span
          class="grain-icon-svg"
          part="grain-icon-svg-wrapper"
          style=${styleMap(wrapperStyles)}
        >
          ${unsafeSVG(icon)}
        </span>
      </span>
    `;
    }
};
Icon.styles = styles;
__decorate([
    property({ type: String })
], Icon.prototype, "name", void 0);
__decorate([
    property({ type: String })
], Icon.prototype, "fill", void 0);
__decorate([
    property({ type: String })
], Icon.prototype, "width", void 0);
__decorate([
    property({ type: String })
], Icon.prototype, "height", void 0);
__decorate([
    property({ type: String })
], Icon.prototype, "class", void 0);
__decorate([
    property({ type: Boolean })
], Icon.prototype, "inverted", void 0);
Icon = __decorate([
    registerCustomElement('grain-icon')
], Icon);
export { Icon };
